export const ApplicationRoutes = {
  jobs: {
    overview: '/jobs'
  },
  purchasing: {
    purchaseOrders: '/purchasing/purchase-orders'
  },
  account: {
    myProfile: '/my-profile',
    login: '/login',
    logout: '/logout',
    resetPassword: '/reset-password',
    confirmEmail: '/confirm-email',
    forgotPassword: '/forgot-password',
    requireReset: '/require-password-reset'
  },
  admin: {
    userManagement: '/admin/user-management',
    companyManagement: '/admin/company-management',
    equipmentManagement: '/admin/equipment-management',
    equipmentHistoryReport: '/admin/equipment-history-report',
    equipmentHistoryReportDetail: '/admin/equipment-history-report/detail',
    hrManagement: '/admin/hr-management',
    dropdownApplicationManagement: '/admin/dropdown-application',
    mailingListManagement: '/admin/mailing-lists'
  },
  safety: {
    dailySafetyCombinedPdf: '/legacy/reporting/daily-safety/combined-pdf',
    safetyTicketReport: '/safety/safety-ticket-report'
  },
  reporting: {
    jobActivity: '/legacy/reporting/job-activity',
    timesheetSummary: '/legacy/reporting/timesheet-summary',
    timesheetSummaryAdmin: '/legacy/admin/timesheet-summary',
    timesheetSummaryField: '/legacy/management/timesheet-summary',
    equipmentUsageV2: '/legacy/reporting/equipment-usage-v2'
  },
  quickLinks: {
    overview: '/quick-links',
    management: '/management/quick-links'
  },
  invoicing: {
    shell: '/invoicing',
    legacyCreate: '/legacy/invoicing/job-invoice',
    v2Create: '/invoicing/create',
    invoiceList: '/invoicing/invoices',
    invoiceApproval: '/legacy/accounting/invoice-approval',
    invoiceEditor: '/invoicing/invoices/:invoiceId',
    invoiceMaster: '/invoicing/invoices/:invoiceId/master',
    invoicePrint: '/invoicing/invoices/:invoiceId/print',
    invoiceCodeManagement: '/legacy/accounting/codes',
    invoiceNumberReport: '/invoicing/invoice-number-report',
    rulesEngineV2: '/invoicing/rules-engine',
    rateSheetManagement: '/admin/rate-sheets',
    accountCodeMapping: '/invoicing/account-code-mapping',
    accountCodeManagement: '/invoicing/account-code-management'
  },
  dev: {
    signalrTest: '/dev/signalr-test'
  },
  util: {
    onLogin: '/'
  }
};
